import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_46: FaireProductEntity = {
  token: "starter_collection_46",
  type: "product",
  name: "Summit Card Case",
  brandName: "Craighill",
  imageUrl: "",
  priceDollars: 68,
  msrpDollars: 136,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
